var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('Navbar')],1),_c('main',{attrs:{"id":"home"}},[_c('Jumbotron'),_c('Products'),_c('CompanyInfo'),_c('Question')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }